import { css } from 'react-emotion'

const styles = {
  noWrap: css({
  }),
  wrap: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    border: '1px solid #e6e6e6',
    position: 'relative',
    minHeight: '36px'
  }),
  comment: css({
    position: 'absolute',
    height: '26px',
    borderRadius: 50,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    fontSize: '12px'
  }),
  selectedImage: css({
    border: '2px solid #fbbd08',
    zIndex: 20
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/CommentStream/CommentStreamStyles.js